export default __webpack_public_path__ + "static/media/checkmark.1a5dd099.svg";